// axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://shop-ecom-wxrn.onrender.com/'
});

export default axiosInstance;

export const weburl = 'https://shop-ecom-wxrn.onrender.com/';
export const shopurl = 'https://shopadmin.servicekarwalo.com/';
export const mainurl = 'https://shopadmin.servicekarwalo.com/';
